import { z } from 'zod';

export const CheckVersionResponseSchema = z.object({
    GIT_COMMIT: z.string(),
});

export type CheckVersionResponse = z.infer<typeof CheckVersionResponseSchema>;
